/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { REMOVE_FAV } from "./actionTypes"
import { apiError, removeFavSuccess } from "./actions"

//Include Both Helper File with needed methods
import { removeFav } from "../../../helpers/backend_helper"

function* add(request) {
  try {
    const response = yield call(removeFav, request.payload.idCourse)
    if (response == undefined) throw new Error("API error")
    yield put(removeFavSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* favRemoveSaga() {
  yield takeEvery(REMOVE_FAV, add)
}

export default favRemoveSaga
